import React, { useState, useEffect} from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Avatar from "./Avatar";
import axios from "axios";
import "./Admin.css";
import emailjs from "@emailjs/browser";

const sendActivationEmail = async (user) => {
  try {
    await emailjs.send(
      "service_cqwf1jr",
      "template_b8rlzej",
      {
        to_name: `${user.FirstName} ${user.LastName}`,
        to_email: user.Email,
        user_type: user.User_Type,
        user_id: user.UserID,   
      },
      "RLVptYs1LmXuoikCr"
    );

    alert("Activation email sent successfully with user credentials.!");
  } catch (error) {
    console.error("Email error:", error);
    alert("User activated, but email failed.!");
  }
};

// Student Modal
const StudentModal = ({ user, onClose, refreshData }) => {
  const isEdit = !!user?.UserID;
  const [editMode, setEditMode] = useState(isEdit);
  const [formData, setFormData] = useState({
    FirstName: user?.FirstName || "",
    LastName: user?.LastName || "",
    Email: user?.Email || "",
    Contact_Number: user?.Contact_Number || "",
    Subjects: user?.Subjects || "",
    Gender: user?.Gender || "Male",
    Grade: user?.Grade || "",
    Board: user?.Board || "",
    School: user?.School || "",
    Parent_Name: user?.Parent_Name || "",
    Parent_Number: user?.Parent_Number || "",
    Parent_Email: user?.Parent_Email || "",
    Slot_Availablity: user?.Slot_Availablity || "",
    active: user?.active || false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? (checked ? 1 : 0) : value });
  };

  const validateForm = () => {
    const requiredFields = [
      "FirstName",
      "LastName",
      "Email",
      "Contact_Number",
      "Subjects",
      "Gender",
      "Grade",
      "Board",
      "School",
      "Parent_Name",
      "Parent_Number",
      "Parent_Email",
      "active"
    ];

    for (let field of requiredFields) {
      if (!formData[field] || formData[field].toString().trim() === "") {
        alert(`${field} is required`);
        return false;
      }
    }
    // Email validation
    const emailFields = ["Email", "Parent_Email"];
    for (let emailField of emailFields) {
      if (!/\S+@\S+\.\S+/.test(formData[emailField])) {
        alert(`Invalid email in ${emailField}`);
        return false;
      }
    }
    return true;
  };

  const previousActive = user?.active || 0;
  const handleSave = async () => {
    if (!validateForm()) return;
    try {
      if (isEdit) {
        //await axios.put(`http://localhost:8000/api/updatestudent/${user.UserID}`, formData);
        await axios.put(`https://alphabeta4success.com/api/updatestudent/${user.UserID}`, formData);
        // ✅ SEND MAIL ONLY WHEN INACTIVE → ACTIVE
        if (previousActive === 0 && formData.active === 1) {
        await sendActivationEmail({
          ...formData,
          User_Type: "Student",
          UserID: user.UserID,
        });
        }
      } else {
        //await axios.post(`http://localhost:8000/api/updatestudent`, { ...formData, User_Type: "Student" });
        await axios.post(`https://alphabeta4success.com/api/updatestudent`, { ...formData, User_Type: "Student" });
      }
      refreshData();
      onClose();
    } catch (err) {
      console.error(err);
      alert("Failed to save student");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>{isEdit ? "Edit Student" : "Add Student"}</h2>
        <button className="modal-close" onClick={onClose}>X</button>
        <div className="modal-body">
          <label>First Name</label>
          <input name="FirstName" value={formData.FirstName} onChange={handleChange} required/>
          <label>Last Name</label>
          <input name="LastName" value={formData.LastName} onChange={handleChange} required/>
          <label>Email</label>
          <input name="Email" value={formData.Email} onChange={handleChange} type="email" required/>
          <label>Contact</label>
          <input name="Contact_Number" value={formData.Contact_Number} onChange={handleChange} required/>
          <label>Subjects</label>
          <input name="Subjects" value={formData.Subjects} onChange={handleChange} required/>
          <label>Gender</label>
          <select name="Gender" value={formData.Gender} onChange={handleChange} required>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          </select>
          <label>Grade</label>
          <input name="Grade" value={formData.Grade} onChange={handleChange} required/>
          <label>Board</label>
          <input name="Board" value={formData.Board} onChange={handleChange} required/>
          <label>School</label>
          <input name="School" value={formData.School} onChange={handleChange} required/>
          <label>Parent/Guardian's Name</label>
          <input name="Parent_Name" value={formData.Parent_Name} onChange={handleChange} required/>
          <label>Parent/Guardian's Contact</label>
          <input name="Parent_Number" value={formData.Parent_Number} onChange={handleChange} required/>
          <label>Parent/Guardian's Email</label>
          <input name="Parent_Email" value={formData.Parent_Email} onChange={handleChange} type="email" required/>
          <label>User Availability</label>
          <textarea name="Availability" rows={5} cols={40} value={formData.Slot_Availablity} onChange={handleChange}/>
          <label>Active</label>
          <input type="checkbox" name="active" checked={formData.active} onChange={handleChange} required/>
        </div>
        <div className="modal-footer">
            <button className="btn-demo" onClick={handleSave}>Update</button>
            <button className="btn-demo" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

// Tutor Modal
const TutorModal = ({ user, onClose, refreshData }) => {
  const isEdit = !!user?.UserID;
  const [editMode, setEditMode] = useState(isEdit);
  const [formData, setFormData] = useState({
    FirstName: user?.FirstName || "",
    LastName: user?.LastName || "",
    Email: user?.Email || "",
    Contact_Number: user?.Contact_Number || "",
    Subjects: user?.Subjects || "",
    Gender: user?.Gender || "Male",
    active: user?.active || false,
    Experience: user?.Experience || "",
    Slot_Availablity: user?.Slot_Availablity || "",
    Tutor_Grade: user?.Tutor_Grade || "",
    Tutor_Board: user?.Tutor_Board || "",
    Qualification: user?.Qualification || "",
    Known_Language: user?.Known_Language || "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? (checked ? 1 : 0) : value });
  };

  const validateForm = () => {
    const requiredFields = ["FirstName", "LastName", "Email", "Contact_Number", "Subjects", "Experience", "Gender","active"];

    for (let field of requiredFields) {
      if (!formData[field] || formData[field].toString().trim() === "") {
        alert(`${field} is required`);
        return false;
      }
    }

    // Email validation
    if (!/\S+@\S+\.\S+/.test(formData.Email)) {
      alert("Invalid email");
      return false;
    }
    return true;
  };

  const previousActive = user?.active || 0;
  const handleSave = async () => {
    if (!validateForm()) return;
    try {
      if (isEdit) {
        //await axios.put(`http://localhost:8000/api/updatetutor/${user.UserID}`, formData);
        await axios.put(`https://alphabeta4success.com/api/updatetutor/${user.UserID}`, formData);
        // ✅ SEND MAIL ONLY WHEN INACTIVE → ACTIVE
        if (previousActive === 0 && formData.active === 1) {
        await sendActivationEmail({
          ...formData,
          User_Type: "Tutor",
          UserID: user.UserID,
        });
        }
      } else {
        //await axios.post(`http://localhost:8000/api/updatetutor`, { ...formData, User_Type: "Tutor" });
        await axios.post(`https://alphabeta4success.com/api/updatetutor`, { ...formData, User_Type: "Tutor" });
      }
      refreshData();
      onClose();
    } catch (err) {
      console.error(err);
      alert("Failed to save tutor");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>{isEdit ? "Edit Tutor" : "Add Tutor"}</h2>
        <button className="modal-close" onClick={onClose}>X</button>
        <div className="modal-body">
          <label>First Name</label>
          <input name="FirstName" value={formData.FirstName} onChange={handleChange} required/>
          <label>Last Name</label>
          <input name="LastName" value={formData.LastName} onChange={handleChange} required/>
          <label>Email</label>
          <input name="Email" value={formData.Email} onChange={handleChange} type="email" required/>
          <label>Contact</label>
          <input name="Contact_Number" value={formData.Contact_Number} onChange={handleChange} required/>
          <label>Subjects you teach</label>
          <input name="Subjects" value={formData.Subjects} onChange={handleChange} required/>
          <label>Grade you teach</label>
          <input name="Tutor_Grade" value={formData.Tutor_Grade} onChange={handleChange} required/>
          <label>Curriculum you are aware of</label>
          <input name="Tutor_Board" value={formData.Tutor_Board} onChange={handleChange} required/>
          <label>Qualification</label>
          <input name="Qualification" value={formData.Qualification} onChange={handleChange} required/>
          <label>Known Language</label>
          <input name="Known_Language" value={formData.Known_Language} onChange={handleChange} required/>
          <label>Experience</label>
          <input name="Experience" value={formData.Experience} onChange={handleChange} type="number" required/>
          <label>Gender</label>
          <select name="Gender" value={formData.Gender} onChange={handleChange} required>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          </select>
          <label>User Availability</label>
          <textarea name="Availability" rows={5} cols={40} value={formData.Slot_Availablity} onChange={handleChange}/>
          <label>Active</label>
          <input type="checkbox" name="active" checked={formData.active} onChange={handleChange} required/>
        </div>
        <div className="modal-footer">
          <button className="btn-demo" onClick={handleSave}>Update</button>
          <button className="btn-demo" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

// Main Component
const UserManagement = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const username = sessionStorage.getItem("username");
    if (!username) {
      navigate("/Signin"); // redirect if not logged in
    }
  }, [navigate]);
  const userName = sessionStorage.getItem("username"); // Replace with dynamic data if needed
  const userImage = "https://broken-link.com/avatar.png"; // Replace with real or test URL
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [modalType, setModalType] = useState(""); // "Student" or "Tutor"
  const [searchQuery, setSearchQuery] = useState("");
  const [istClock, setIstClock] = useState("");

  const fetchUsers = async () => {
    try {
      //const res = await axios.get("http://localhost:8000/api/inactiveusers");
      const res = await axios.get("https://alphabeta4success.com/api/inactiveusers");
      setUsers(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const searchUsers = async () => {
    if (searchQuery.trim() === "") {
      fetchUsers();
      return;
    }
    try {
      //const res = await axios.get(`http://localhost:8000/api/search/${searchQuery}`);
      const res = await axios.get(`https://alphabeta4success.com/api/search/${searchQuery}`);
      setUsers(res.data);
    } catch (err) {
      console.error(err);
    }
  };
  
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this user?")) return;
    try {
      //await axios.delete(`http://localhost:8000/api/deleteusers/${id}`);
      await axios.delete(`https://alphabeta4success.com/api/deleteusers/${id}`);
      alert("User deleted successfully");
      fetchUsers();
    } catch (err) {
      console.error(err);
    }
  };

  const handleDemo = async (id) => {
    try {
      //await axios.put(`http://localhost:8000/api/demo/${id}`);
      await axios.put(`https://alphabeta4success.com/api/demo/${id}`);
      alert("Demo flag updated successfully");
      fetchUsers();
    } catch (err) {
      console.error(err);
      alert("Failed to update demo flag");
    }
  };

  const openModal = (user) => {
    setSelectedUser(user);
    setModalType(user.User_Type);
  };

  const openAddModal = (type) => {
    setSelectedUser(null);
    setModalType(type);
  };

  const closeModal = () => {
    setSelectedUser(null);
    setModalType("");
  };

  useEffect(() => { 
    
    fetchUsers(); 
    
    const clockInterval = setInterval(() => {
      const ist = new Date().toLocaleTimeString("en-IN", {
        hour12: true,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZone: "Asia/Kolkata",
      });
      setIstClock(ist);
    }, 1000);

    return () => {
      clearInterval(clockInterval);
    };
  }, []);

  return (
    <div>
      <section id="sidebar">
        <Link to="#" className="brand">
        <img
          src="/Assets/images/AB4S_logo.png"
          alt="AB4S"
          className="sidebar-logo"
        />
        </Link>
        <ul className="side-menu top">
          <li><Link to="/AdminDashboard"><i className="bx bxs-dashboard"></i><span className="text">Dashboard</span></Link></li>
          <li><a href="https://alphabeta4success.com/action.html" target="_blank"
              rel="noopener noreferrer"><i className="bx bx-video"></i><span className="text">Classroom</span></a></li>
          <li><Link to="#"><i className="bx bx-file"></i><span className="text">File Manager</span></Link></li>
          <li><Link to="/Allocation"><i className="bx bxs-book-content"></i><span className="text">Allocation</span></Link></li>
          <li><Link to="/Scheduler"><i className="bx bxs-calendar-check"></i><span className="text">Re-scheduler</span></Link></li>
          <li className="active"><Link to="/UserManagement"><i className="bx bxs-group"></i><span className="text">User Management</span></Link></li>
          <li><Link to="/Contacts"><i className="bx bx-id-card"></i><span className="text">Contacts</span></Link></li>
          <li><Link to="/Reports"><i className="bx bx-download"></i><span className="text">Reports</span></Link></li>
          <li><Link to="/ResetPassword"><i className="bx bx-message-edit"></i><span className="text">Reset Password</span></Link></li>
          <li><Link to="#"><i className="bx bx-calendar-event"></i><span className="text">Calender</span></Link></li>
        </ul>
        <ul className="side-menu">
          <li><Link to="#"><i className="bx bxs-cog"></i><span className="text">Settings</span></Link></li>
          <li><Link to="/Signin" className="logout"><i className="bx bx-log-out"></i><span className="text">Logout</span></Link></li>
        </ul>
      </section>
      <section id="content">
      <nav>
          <i className="bx bx-menu"></i>
          <h3><span className="highlight-purple">Happy Learning <i className='bx bxs-smile'></i></span></h3>
          <form onSubmit={(e) => { e.preventDefault(); searchUsers(); }}>
            <div className="form-input">
              <input type="search" placeholder="Search by Username..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}/>
              <button type="submit" className="search-btn" onClick={searchUsers}>
                <i className="bx bx-search"></i>
              </button>
            </div>
          </form>
          <input type="checkbox" id="switch-mode" hidden />
          <label htmlFor="switch-mode" className="switch-mode"></label>
          <div className="topbar-right" style={{ display: "flex", alignItems: "center", gap: 30 }}>
            <span style={{ marginRight: "6px", fontWeight: 600 }}>
              ⏰ -  {istClock} : IST
            </span>
            <span style={{ marginLeft: 8 }}><h3>Welcome, {userName}</h3></span>
            <Avatar name={userName} src={userImage} size={30} className="avatar" />
          </div>
        </nav>
        <main>
        <div className="head-title">
            <div className="left">
              <h2>User Management</h2>
              <ul className="breadcrumb">
              </ul>
            </div>
          </div>
           <div className="table-data">
          <table className="user-table">
            <thead>
              <tr>
                  <th>UserID</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Contact_Number</th>
                  <th>Whatsapp_Number</th>
                  <th>Gender</th>
                  <th>User_Type</th>
                  <th>Subjects</th>
                  <th>Country</th>
                  <th>Status</th>
                  <th colSpan={2} align="center" >Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.length ? users.map(user => (
                <tr key={user.UserID}>
                  <td>
                    <button className="link-button" onClick={() => openModal(user)}>
                      {user.UserID}
                    </button>
                  </td>
                  <td>{user.FirstName}</td>
                  <td>{user.LastName}</td>
                  <td>{user.Email}</td>
                  <td>{user.Contact_Number}</td>
                  <td>{user.Whatsapp_number}</td>
                  <td>{user.Gender}</td>
                  <td>{user.User_Type}</td>
                  <td>{user.Subjects}</td>
                  <td>{user.Country}</td>
                  <td>{user.Status}</td>
                  <td>
                    <button className="btn-demo" onClick={() => handleDemo(user.UserID)}>Demo</button>
                    <button className="btn-delete" onClick={() => handleDelete(user.UserID)}>Delete</button>
                  </td>
                </tr>
              )) : <tr><td colSpan="12">No users found.</td></tr>}
            </tbody>
          </table>
          </div> 
        </main>

        {modalType === "Student" &&
          <StudentModal user={selectedUser} onClose={closeModal} refreshData={fetchUsers} />}
        {modalType === "Tutor" &&
          <TutorModal user={selectedUser} onClose={closeModal} refreshData={fetchUsers} />}
      </section>
    </div>
  );
};

export default UserManagement;
